export class ProfileDataSavingException extends Error {}
